import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% di sconto extra',
  [OfferKindEnum.PercentageOffByProducts]: '{{percentageAmount}}% di sconto extra',
  [OfferKindEnum.AmountOffByProducts]: '{{amount}} di sconto extra',
  [OfferKindEnum.Bogo]: '2 PER 1',
  [OfferKindEnum.BogoHalfPrice]: 'Compra 1 prendi 1 a metà prezzo!',
  [OfferKindEnum.FreeItemByProducts]: 'Articolo gratuito',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Articolo gratuito',
};

export default OfferBadge;
